/* @ngInject */
const metadata = (
  wagonFields,
  wagonButtons
) => {
  const self = {}

  self.favoriteSort = ['area', 'railway', 'position',]

  self.badges = wagonButtons.badges

  self.buttons = [
    wagonButtons.search,
    wagonButtons.edit,
    wagonButtons.scrap,
    wagonButtons.delete,
  ]

  self.fields = wagonFields

  return self
}

export default metadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/services/metadata.service.js